import './Navbar.scss';
import { useState } from 'react';

export default function Navbar() {
    const [showMenu, setShowMenu] = useState(false);

    return (
      <>
        <header>
            <div className="navigation-wrapper">
                <div className="navigation-title">Healthy with Daphne</div>
                <nav className={"navigation " + (showMenu ? 'open' : '')}>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/emb-test">EMB Test</a></li>
                        <li><a href="/aanbod">Aanbod</a></li>
                        <li><a href="/over-mij">Over mij</a></li>
                        <li><a href="/contact">Contact</a></li>
                    </ul>
                </nav>
                <button aria-expanded="false" aria-controls="example-panel" className={"hamburger-icon " + (showMenu ? 'open' : '')} onClick={() => setShowMenu(!showMenu)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </header>      
    </>
    );
  }